var d = /* @__PURE__ */ ((r) => (r.Small = "sm", r.Medium = "md", r.Large = "lg", r))(d || {});
const l = "md";
export {
  d as BaseSizeEnum,
  l as DEFAULT_SIZE
};
//# sourceMappingURL=common.js.map
